import React, { useRef, useState, useEffect, useMemo } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './products-item.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import './dialog.css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import Carousel from 'react-bootstrap/Carousel';
import { Virtual, Navigation, Pagination, Autoplay } from 'swiper/modules';
import CloseCollapse from '../../assets/icons/close-collaps.svg';

import { Skeleton } from 'primereact/skeleton';
import ProductImage from '../../assets/images/defult-img.svg';
import Collapse from '../../assets/icons/collapse.svg';
import { imgBaseUrl2 } from '../../utils/api';
import { Dialog } from 'primereact/dialog';

// Uncomment and use if API is integrated
import { getProductsBySearch, imgBaseUrl } from '../../utils/api';

export default function ProductsSlider({ productCat, products }) {
  const [swiperRef, setSwiperRef] = useState(null);
  // const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false); // حالت لودینگ
  const [visible, setVisible] = useState(false); // Dialog visibility state
  const [dialogContent, setDialogContent] = useState({}); // Dialog content state
  const [isScrolling, setIsScrolling] = useState(false); // فلگ برای تشخیص اسکرول
  const carouselRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const [sliderKey, setSliderKey] = useState(0);

  const prevLength = useRef(products.length);

  // ✅ بهینه‌سازی شده با useMemo برای جلوگیری از محاسبه‌ی غیرضروری
  const filteredProducts = useMemo(() => {
    const filtered = productCat === 'isFavorit'
      ? products.filter((product) => product.isFavorit && product.isActive === true)
      : productCat === 'isNew'
        ? products.filter((product) => product.isNew && product.isActive === true)
        : products.filter((product) => product.isActive === true);

    // مرتب‌سازی براساس code (صعودی)
    return filtered.sort((a, b) => b.code.localeCompare(a.code));
  }, [productCat, products]);

  useEffect(() => {
    if (prevLength.current !== filteredProducts.length) {
      const timer = setTimeout(() => {
        setSliderKey(prevKey => prevKey + 1);
      }, 100); // جلوگیری از تغییرات پشت سرهم

      prevLength.current = filteredProducts.length; // ذخیره مقدار قبلی
      return () => clearTimeout(timer);
    }
  }, [filteredProducts]);


  const settings = {
    arrows: filteredProducts && filteredProducts.length > 0, // نمایش یا عدم نمایش پیکان‌ها
    autoplaySpeed: 3000,

    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          rtl: filteredProducts && filteredProducts.length > 4,
          autoplay: filteredProducts && filteredProducts.length > 4, // فعال‌سازی خودکار
          draggable: filteredProducts && filteredProducts.length > 4,
          infinite: filteredProducts && filteredProducts.length > 4, // حلقه‌ای شدن اسلایدر
        },
      },
      {
        breakpoint: 1500,
        settings: {
          rtl: filteredProducts && filteredProducts.length > 4,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: filteredProducts && filteredProducts.length > 4, // فعال‌سازی خودکار
          draggable: filteredProducts.length > 4,
          infinite: filteredProducts.length > 4, // حلقه‌ای شدن اسلایدر
        },
      },
      {
        breakpoint: 1100,
        settings: {
          rtl: filteredProducts && filteredProducts.length > 3,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: filteredProducts && filteredProducts.length > 3, // فعال‌سازی خودکار
          draggable: filteredProducts.length > 3,
          infinite: filteredProducts.length > 3, // حلقه‌ای شدن اسلایدر
        },
      },
      {
        breakpoint: 900,
        settings: {
          rtl: filteredProducts && filteredProducts.length > 3,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: filteredProducts.length > 3, // اضافه کردن autoplay در اینجا
          autoplaySpeed: 3000,
          draggable: filteredProducts.length > 3,
          infinite: filteredProducts.length > 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          rtl: filteredProducts && filteredProducts.length > 2,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          autoplay: filteredProducts.length > 2, // اضافه کردن autoplay در اینجا
          autoplaySpeed: 3000,
          draggable: filteredProducts.length > 2,
          infinite: filteredProducts.length > 2,
        },
      },
    ],
  };


  // برای جلوگیری از فراخوانی بیش از حد در هر حرکت موس
  const throttle = (func, delay) => {
    let lastCall = 0;
    return (...args) => {
      const now = Date.now();
      if (now - lastCall >= delay) {
        lastCall = now;
        func(...args);
      }
    };
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const handleMouseMove = throttle((e) => {
    if (!isDragging) return;

    setCurrentX(e.clientX);
  }, 16); // مقدار 16ms برای استفاده از throttle و جلوگیری از فراخوانی زیاد تابع

  const handleMouseUp = () => {
    setIsDragging(false);
    const deltaX = currentX - startX;

    if (deltaX > 50) {
      if (carouselRef.current) {
        carouselRef.current.prev(); // اسلاید قبلی
      }
    } else if (deltaX < -50) {
      if (carouselRef.current) {
        carouselRef.current.next(); // اسلاید بعدی
      }
    }

    // ریست مقادیر
    setStartX(0);
    setCurrentX(0);
  };

  // جلوگیری از تغییر اسلاید هنگام کلیک روی دکمه‌ها
  const handleButtonClick = (e) => {
    e.stopPropagation(); // جلوگیری از پراپگیشن رویداد
  };

  const openDialog = (product) => {
    setDialogContent(product);
    setVisible(true);
  };

  // Disable/Enable scroll when dialog is opened/closed
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [visible]);
  const handleMouseDownslid = () => setIsScrolling(false);
  const handleMouseMoveslid = () => setIsScrolling(true);
  const handleMouseUpslid = (productId) => {
    if (!isScrolling) {
      window.location.href = `/product?id=${productId}`;
    }
  }

  const getDefaultImage = (images) => {
    if (!images || images.length === 0) return ProductImage;
    const defaultImg = images.find(img => img.isDefault);
    return defaultImg
      ? imgBaseUrl2 + 'io/230x230/' + defaultImg.url
      : imgBaseUrl2 + 'io/230x230/' + images[0].url;
  };



  return (
    <>
      {loading && products.length > 0 ? (
        <div className="skeleton-wrapper container">
          <Slider {...settings} rtl={true}>
            {[...Array(5)].map((_, index) => (
              <div className="product-item" key={index}>
                <div className="product-img">
                  <Skeleton className="img-box img-product h-100" />
                </div>
                <div className="detail">
                  <Skeleton className="mt-4" />
                  <Skeleton className="mt-2" />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <Slider {...settings} adaptiveHeight={true} key={sliderKey}>
          {filteredProducts.map((product, index) => {

            return (
              <div className="product-item" key={product.id}>
                <div
                  className="product-img aspect-[3/3]"

                  style={{ cursor: 'pointer' }}
                  onMouseDown={handleMouseDownslid}
                  onMouseMove={handleMouseMoveslid}
                  onMouseUp={() => handleMouseUpslid(product.id)}
                >
                  <img
                    width="1200"
                    height="600"
                    src={getDefaultImage(product.images)}
                    loading={index === 0 ? "eager" : "lazy"}
                    fetchpriority={index === 0 ? "high" : "auto"}
                    draggable={false}
                    className="img-box img-product"
                    alt={product.title}
                  />
                </div>
                <div className="detail">
                  <h4 className="mt-4">{product.title}</h4>
                  <h6 className="" dir="rtl">
                    {product && product.lables
                      ? product.lables.filter(Boolean).join(' , ')
                      : ''}
                  </h6>                </div>
                <div className="max-btn">
                  <div className="max-btn-top"></div>
                  <div className="max-btn-down"></div>
                  <button className="btn" onClick={() => openDialog(product)}>
                    <img src={Collapse} alt="Collapse" />
                  </button>
                </div>
              </div>
            );
          })}
        </Slider>
      )}

      {/* Dialog with Carousel for Product Details */}
      <Dialog
        visible={visible}
        style={{ width: '24vw' }}
        breakpoints={{ '1800px': '25vw', '1600px': '24vw', '1100px': '60vw', '900px': '60vw', '600px': '400vw', '500px': '95vw' }}
        onHide={() => setVisible(false)}
        className="custom-dialog"
      >
        <div onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={() => setIsDragging(false)}
          style={{ cursor: isDragging ? "grabbing" : "grab" }}>
          <Carousel
            ref={carouselRef}
            indicators={
              dialogContent &&
              dialogContent.images &&
              dialogContent.images.length > 1
            }
          >
            {(dialogContent.images && dialogContent.images.length > 0
              ? dialogContent.images
              : [ProductImage]
            ).map((image, index) => (
              <Carousel.Item key={index}>
                <div className="img-box">
                  <img
                    src={image.url ? imgBaseUrl2 + 'io/420x420/' + image.url || image : image}
                    className="img-slider"
                    alt={`Product ${index + 1}`}
                    draggable={false}
                  />
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
          <h4>{dialogContent.title}</h4>
          <p className='mb-1'>
            توضیحات محصول:{' '}
            {dialogContent.description || 'این محصول فاقد توضیحات می‌باشد.'}
          </p>
          <h6 className="" dir="rtl">
            {dialogContent && dialogContent.lables
              ? dialogContent.lables.filter(Boolean).join(' , ')
              : ''}
          </h6>
          <div className='dailog-max-btn-right'></div>
          <div className='dailog-max-btn-left'></div>
          <div className='bg-modal'>
            <div className="dailog-max-btn">

              <button className="btn" onClick={() => setVisible(false)}>
                <img src={CloseCollapse} alt="Collapse" />
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
